import { getUrl } from "aws-amplify/storage";

export default async function generateSignedURL(objectKey, expiresIn = 60) {
  try {
    // Generate the signed URL
    const getUrlResult = await getUrl({
      path: objectKey, // Path to the S3 object (e.g., 'public/pronunciation/lopta.wav')
      options: {
        validateObjectExistence: true, // Attempt to validate the existence of the object
        expiresIn: expiresIn, // URL will be valid for 60 seconds
        useAccelerateEndpoint: false, // Set to true if using S3 Transfer Acceleration
      },
    });

    return getUrlResult || "";
  } catch (error) {
    // Catch the specific error related to non-existent objects or other errors
    if (error.message.includes("not exist")) {
      console.error(`Object with key ${objectKey} not found in S3.`);
    } else {
      console.error("Failed to generate signed URL: ", error);
    }
    return "";
  }
}
